import { OrganizationUserDetailsState } from "@idw-types/state/organization-user-details-state";
import { OrganizationUserDetailsActionTypes, OrganizationUserDetailsActions } from "../actions/organization-user-details-actions";

export const initialOrganizationUserDetailsState: OrganizationUserDetailsState = {
    organizationUser: {
        isLoading: false,
        organizationUser: null
    }
};

export const organizationUserDetailsReducer = (
    state: OrganizationUserDetailsState = initialOrganizationUserDetailsState,
    action: OrganizationUserDetailsActions
): OrganizationUserDetailsState => {
    switch (action.type) {
        // Organization User Details
        case OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS_LOADING:
            return {
                ...state,
                organizationUser: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationUserDetailsState.organizationUser }
                        : { ...state.organizationUser }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS:
            return {
                ...state,
                organizationUser: {
                    organizationUser: action.payload.axnAdminUser,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};